import { createDecorator } from "../../../../platform/instantiation/common/registry.js";
import type { IOperationService as IOperationServiceInterface } from "./operations.js";

/**
 * The service IDENTIFIER alone, in a LEAF module: the UndoableCommand base
 * (platform/commands) resolves the op service for the enforced log half of
 * undo/redo (H1), and importing the full operations module from there closes
 * a runtime import cycle (operations → documentTarget → webgl helpers → …
 * back into commands/actions — TDZ crash on decorators). The back-import
 * above is TYPE-ONLY and erased at runtime; operations.ts re-exports this
 * identifier so every existing consumer keeps its import path.
 */
export const IOperationService = createDecorator<IOperationServiceInterface>("operationService");
